export function ControlWrapper({ children }: { children: React.ReactNode }) {
  return <div className="space-y-2 w-max-500">{children}</div>;
}